
function cartesian<T>(...tail: T[][]): Generator<T[][]>
function* cartesian<T>(head: T[], ...tail: T[][]): Generator<T[][]> {
    let remainder = tail.length ? cartesian(...tail) : [[]];
    for (let r of remainder) for (let h of head) yield [h as any, ...r];
}

export function getAllCombosFromArrays<T>(...arrays: T[][]): T[][] {
    if (!arrays.length) return [];
    return [...cartesian.apply(0, arrays)] as T[][];
}
